import { Pipe, PipeTransform } from "@angular/core";
import currency from "currency.js";
import Options = currency.Options;

/*
 * uses currency.js as an engine
 */
@Pipe({ name: "currency" })
export class CurrencyPipe implements PipeTransform {
  transform(
    param: any,
    options: Options = {
      separator: " ",
      decimal: ".",
      precision: 2,
    },
  ): number {
    // Replace comma with dot for decimal separator
    if (typeof param === "string" && param.includes(",")) {
      param = param.replace(",", ".");
    }
    return currency(param, options).value;
  }
}
